import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { getMapValue } from '../../utils';

const InputField = (props) => {
	const { input, label, placeholder, required, type, meta: { touched, error }, formErrors } = props;
	let value = input && input.value
	return (
		<React.Fragment>
			<label className="col-form-label">{label} {required && (<span style={{color:"red"}}>*</span>)}</label>
			<input
				{...input}
				{...props}
				type={type}
				placeholder={placeholder}
				className="form-control form-control-md"   
			/>
			{touched && (error && <small className="form-text text-danger">{error}</small>)}
			{touched && (formErrors && <small className="form-text text-danger">
			{ formErrors && 
				formErrors.hasOwnProperty(input.name) && 
				getMapValue(formErrors, input.name).map(err => {
					return err;
				})
			}</small>)}
		</React.Fragment>
	);
}

export default InputField;

